import team from './team';
import cars from './cars';
import services from './services';
import portfolio from './portfolio';
import events from './events';
import { positions } from './career';
import blogs from './blogs';
import products from './products';


const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-Us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink : {link: '#', title: 'Car'},
        subLink: [
            { id: 1, link: "/Cars", title: "Cars" },
            { id: 2, link: "/Car-Grid", title: "Car Grid" },
            { id: 3, link: "/Car-List", title: "Car List" },
            { id: 4, link: "/Cars-Type", title: "Cars Type" },
            { id: 5, link: "/Cars/Car-Single", title: "Car Single",  state: cars[0] },
            { id: 6, link: "/Car-Booking", title: "Car Booking" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },
    {
        id: 5,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Pricing", title: "Pricing" },
            { id: 2, link: "/Features", title: "Features" },
            { id: 3, link: "/Process", title: "Work Process" },
            { id: 4, link: "/Offers", title: "Offers" },
            { id: 5, link: "/Gallery", title: "Gallery"  },
            {
                id: 6,
                title: "Portfolio",
                children: [
                    { id: 1, link: "/Portfolio", title: "Portfolio" },
                    { id: 2, link: "/Portfolio/Portfolio-Single", title: "Portfolio Single",  state: portfolio[0] },
                ],
            },
            {
                id: 7,
                title: "Event",
                children: [
                    { id: 1, link: "/Events", title: "Events" },
                    { id: 2, link: "/Events/Event-Single", title: "Event Single",  state: events[0] },
                ],
            },
            {
                id: 8,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single",  state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
            {
                id: 9,
                title: "Information Hub",
                children: [
                    { id: 1, link: "*", title: "Not Found" },
                    { id: 2, link: "/Privacy-Policy", title: "Privacy Policy" },
                    { id: 3, link: "/Services-Terms", title: "Terms & Conditions" },
                ]
            },
            { id: 10, link: "/Partners", title: "Partners" },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;